import React from "react";
import { catalogCardSx } from "../components/catalogStyles";
import { Box, Typography, useTheme } from "@mui/material";
import { ProjectDefinition } from "./projectDefinitions";

interface ProjectItemProps {
  project: ProjectDefinition;
}

export function ProjectItem({ project }: ProjectItemProps) {
  const theme = useTheme();

  return (
    <Box
      component="a"
      href={project.href}
      target="_blank"
      rel="noopener noreferrer"
      className="site-motion"
      data-testid="project-card"
      sx={{
        ...catalogCardSx(theme),
        display: "flex",
        alignItems: "center",
        gap: 2,
        padding: 2.5
      }}
    >
      <Box
        sx={{
          width: "44px",
          height: "44px",
          borderRadius: "10px",
          background: project.image
            ? "none"
            : `linear-gradient(135deg, ${theme.palette.accent2}, ${theme.palette.accent3})`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.2rem",
          flexShrink: 0,
          overflow: "hidden"
        }}
      >
        {project.image ? (
          <img
            src={project.image}
            alt={project.title}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        ) : (
          (project.icon ?? "\uD83D\uDCC1")
        )}
      </Box>
      <Box sx={{ minWidth: 0, overflowWrap: "anywhere" }}>
        <Typography sx={{ fontSize: "1rem", fontWeight: 500 }}>
          {project.title}
        </Typography>
        <Typography sx={{ fontSize: "0.875rem", color: theme.palette.textDim }}>
          {project.desc ?? ""}
        </Typography>
        <Typography sx={{ fontSize: "0.75rem", color: theme.palette.accent }}>
          {project.href.replace(/^https?:\/\//, "")}
        </Typography>
      </Box>
    </Box>
  );
}
